import React, { lazy, useEffect, useState } from "react";
// import Slider from '../../../components/slider/slider'

import Banner from "../../../components/slider/slider";
// import { Swiper, SwiperSlide } from 'swiper/react';

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import { newsMenu } from '../../../localData/newsMenu/newsMenu';

// import {
//   Autoplay,
//   Pagination,
//   Navigation,
//   // EffectCoverflow
// } from 'swiper'

import cutLIcon from "../../../images/icons/adoption.png";
import saveMoneyIcon from "../../../images/icons/growth-graph.png";
import friendly from "../../../images/icons/trophy.png";
import techIcon from "../../../images/icons/settings.png";
import humanIcon from "../../../images/icons/group.png";
import technologyIcon from "../../../images/icons/project-management1.png";

import AOS from "aos";
import "aos/dist/aos.css";
import "swiper/css";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "../../../language/i18n";
import { normalizeLang } from "../../../utils/localeDataLoader";
import { getIntroduceOverviewByLanguage } from "../../../apis/introduceOverviews";
import { getIntroduceCapacitiesByLanguage } from "../../../apis/introduceCapacities";

// import { useParams } from 'react-router-dom';
import HomeTitle from "./homeTitle";
import LazySection from "./LazySection";
import HomeVitalsBackground from "./HomeVitalsBackground";
import VantaAurora from "../../../components/vantaAurora/VantaAurora";

const ListProjectSolution = lazy(() => import("./listProjectSolution"));
const LogoSlider = lazy(() => import("./LogoSlider"));
const EsmSection = lazy(() => import("./EsmSection"));
const TypicalProject = lazy(() => import("./typicalProject"));
const ListTypicalInProgress = lazy(() => import("./ListTypicalInProgress"));
const LazySection4 = lazy(() => import("./section4"));
const HomeNewsSection = lazy(() => import("./HomeNewsSection"));

function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [overviewSummary, setOverviewSummary] = useState("");
  const [capacitiesData, setCapacitiesData] = useState([]);

  useEffect(() => {
    const languageCode = normalizeLang(i18n.language);
    if (languageCode === "vi" && location.pathname === "/home") {
      navigate("/trang-chu", { replace: true });
    } else if (languageCode !== "vi" && location.pathname === "/trang-chu") {
      navigate("/home", { replace: true });
    }
  }, [i18n.language, location.pathname, navigate]);

  useEffect(() => {
    const loadOverviewSummary = async () => {
      try {
        const languageCode = normalizeLang(i18n.language);
        const data = await getIntroduceOverviewByLanguage(languageCode);
        setOverviewSummary(data?.summary || "");
      } catch (error) {
        console.error("Failed to load overview summary:", error);
      }
    };
    loadOverviewSummary();
    i18n.on("languageChanged", loadOverviewSummary);
    return () => {
      i18n.off("languageChanged", loadOverviewSummary);
    };
  }, []);

  useEffect(() => {
    const loadCapacities = async () => {
      try {
        const languageCode = normalizeLang(i18n.language);
        const data = await getIntroduceCapacitiesByLanguage(languageCode);
        setCapacitiesData(data);
      } catch (error) {
        console.error("Failed to load capacities:", error);
      }
    };
    loadCapacities();
    i18n.on("languageChanged", loadCapacities);
    return () => {
      i18n.off("languageChanged", loadCapacities);
    };
  }, []);

  // const [count, setCount] = useState(1);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     if (count < 00) {
  //       setCount(count + 1);
  //     } else {
  //       clearInterval(intervalId);
  //     }
  //   }, 20);
  //   return () => clearInterval(intervalId);
  // }, [count]);

  // useEffect(() => {
  //   // 👇️ scroll to top on page load
  //   window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  // }, []);

  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <div className="home">
      <Banner />
      <section
        className="section-fullscreen home-intro"
        style={{ perspective: "20px" }}
      >
        <div className="section-img" style={{ transformStyle: "preserve-3d" }}>
          <HomeVitalsBackground variant="intro" />
          <div className="layout_container section1">
            <div className="section1-left" aria-hidden="true">
              <span className="section1-left__badge">HSV</span>
            </div>
            <div className="section1-right">
              <div
                className="section1-copy"
                style={{ transform: "translateZ(-10px) scale(1.)" }}
                data-aos="fade-down"
                data-aos-once="true"
                data-aos-delay="200"
              >
                <p>{t("home.introduction_title")}</p>
                <h4>{t("home.introduction_subtitle")}</h4>
                <p>{overviewSummary}</p>
              </div>
              <div className="section1-model">
                <div
                  data-aos="fade-right"
                  data-aos-once="true"
                  data-aos-delay="300"
                >
                  <img src={technologyIcon} alt="technology icon" />
                  <p className="subtitle">{capacitiesData[1]?.subtitle}</p>
                  <div
                    className="description"
                    dangerouslySetInnerHTML={{
                      __html: capacitiesData[1]?.description,
                    }}
                  />
                </div>
                <div
                  data-aos="fade-left"
                  data-aos-once="true"
                  data-aos-delay="300"
                >
                  <img src={humanIcon} alt="human icon" />
                  <p className="subtitle">{capacitiesData[0]?.subtitle}</p>
                  <div
                    className="description"
                    dangerouslySetInnerHTML={{
                      __html: capacitiesData[0]?.extraDescription,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-fullscreen">
        <div
          className="layout_container section2 p-bt-100"
          style={{ padding: "0 0 50px 0" }}
        >
          <div>
            <div className="section2-content row">
              <div
                className="col-12 col-sm-6 col-md-6 col-xl-3"
                data-aos="fade-up"
                data-aos-once="true"
                data-aos-delay="100"
              >
                <div className="section2-content-item">
                  <div className="section2-visual" aria-hidden="true">
                    <span className="section2-visual__ring--outer" />
                    <span className="section2-visual__icon">
                      <img src={cutLIcon} alt="pencil icon" />
                      <span>{t("home.years_established")}</span>
                    </span>
                    <span className="section2-visual__orbit">
                      <i />
                    </span>
                  </div>
                  <p className="section2-desc">{t("home.years_desc")}</p>
                </div>
              </div>
              <div
                className="col-12 col-sm-6 col-md-6 col-xl-3"
                data-aos="fade-up"
                data-aos-once="true"
                data-aos-delay="200"
              >
                <div className="section2-content-item">
                  <div className="section2-visual" aria-hidden="true">
                    <span className="section2-visual__ring--outer" />
                    <span className="section2-visual__icon">
                      <img src={saveMoneyIcon} alt="money icon" />
                      <span>{t("home.revenue_target")}</span>
                    </span>
                    <span className="section2-visual__orbit">
                      <i />
                    </span>
                  </div>
                  <p className="section2-desc">{t("home.revenue_desc")}</p>
                </div>
              </div>
              <div
                className="col-12 col-sm-6 col-md-6 col-xl-3"
                data-aos="fade-up"
                data-aos-once="true"
                data-aos-delay="300"
              >
                <div className="section2-content-item">
                  <div className="section2-visual" aria-hidden="true">
                    <span className="section2-visual__ring--outer" />
                    <span className="section2-visual__icon">
                      <img src={techIcon} alt="tech icon" />
                      <span>{t("home.top_12_solutions")}</span>
                    </span>
                    <span className="section2-visual__orbit">
                      <i />
                    </span>
                  </div>
                  <p className="section2-desc">{t("home.top_12_desc")}</p>
                </div>
              </div>
              <div
                className="col-12 col-sm-6 col-md-6 col-xl-3"
                data-aos="fade-up"
                data-aos-once="true"
                data-aos-delay="400"
              >
                <div className="section2-content-item">
                  <div className="section2-visual" aria-hidden="true">
                    <span className="section2-visual__ring--outer" />
                    <span className="section2-visual__icon">
                      <img src={friendly} alt="friendly icon" />
                      <span>{t("home.awards")}</span>
                    </span>
                    <span className="section2-visual__orbit">
                      <i />
                    </span>
                  </div>
                  <p className="section2-desc">{t("home.awards_desc")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <HomeVitalsBackground />

      <LazySection animation="fade-up">
        <section className="section-fullscreen">
          <div
            id="home-solutions"
            className="layout_container home_ourservices home-products"
          >
            <HomeTitle
              text={t("home.products_text")}
              title={t("home.products_title")}
            />
            <ListProjectSolution />
          </div>
        </section>
      </LazySection>

      <HomeVitalsBackground />

      <LazySection animation="fade-up">
        <section
          className="section-fullscreen section-mint-bg"
          style={{ padding: 0 }}
        >
          <VantaAurora className="home_ourservices home-brand-showcase">
            <div className="layout_container" style={{ paddingBottom: "50px" }}>
              <HomeTitle
                text={t("home.services_text")}
                title={t("home.services_title")}
              />
              <LogoSlider />
            </div>
          </VantaAurora>
        </section>
      </LazySection>

      <HomeVitalsBackground />

      <LazySection animation="fade-left">
        <section className="section-fullscreen section-mint-bg">
          <div className="home_ourservices layout_container home-esm-showcase">
            <HomeTitle text={t("home.esm_text")} title={t("home.esm_title")} />
            <EsmSection />
          </div>
        </section>
      </LazySection>

      <HomeVitalsBackground />

      <LazySection animation="fade-up">
        <section className="section-fullscreen section-mint-bg">
          <div className="layout_container home_ourservices home-case-studies">
            <HomeTitle
              text={t("home.typical_projects_text")}
              title={t("home.typical_projects_title")}
            />
            <TypicalProject />
          </div>
        </section>
      </LazySection>

      <HomeVitalsBackground />

      <LazySection animation="fade-right">
        <section className="section-fullscreen section-mint-bg">
          <div className="layout_container home_ourservices home-case-studies in-progress-projects">
            <HomeTitle
              text={t("home.in_progress_text")}
              title={t("home.in_progress_title")}
            />
            <ListTypicalInProgress />
          </div>
        </section>
      </LazySection>

      <HomeVitalsBackground />

      <LazySection animation="zoom-in">
        <div>
          <LazySection4 />
        </div>
      </LazySection>

      {/* <section className='section-fullscreen'>
        <div className="layout_container home_clientsWords">
          <HomeTitle text="Bộ Máy Công Ty" title="Ban Lãnh Đạo" />
          <div className='home_clientsWords-content'>
            <ul className='row'>
              {leaders.map((value, index) => {
                if (value.category === 1) {
                  return (
                    <div className='col-sm-6 col-md-3 col-lg-4'
                      key={index}
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/leader/${value.category}/${value.slug}`)}>
                      <li key={index}>
                        <div>
                          <img src={value.img} alt="" />
                        </div>
                        <p style={{ fontWeight: "600", color: "#333", marginBottom: "10px" }}>{value.gender === 1 ? "Ông" : "Bà"}: {value.name}</p>
                        <ul className='category_leader'>
                          {
                            value.position.map((positionValue, positionIndex) => (
                              <li key={positionIndex}>
                                <span>{positionValue}</span>
                              </li>
                            ))
                          }
                          <p className='leader-summary'>{value.summary}</p>
                        </ul>
                      </li>
                    </div>
                  );
                }
                return null; 
              })}
            </ul>
          </div>
        </div>
      </section> */}

      <HomeVitalsBackground />

      <LazySection animation="fade-up">
        <HomeNewsSection />
      </LazySection>
    </div>
  );
}

export default Home;
